const env = Object.freeze({
    apiUrl: process.env.REACT_APP_API_URL,
    graphqlUrl: process.env.REACT_APP_GRAPHQL_URL,
    websocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
    environment: process.env.REACT_APP_ENV,
    isProduction: process.env.REACT_APP_ENV === 'production',
    isAcceptance: process.env.REACT_APP_ENV === 'acceptance',
    debug: process.env.REACT_APP_ENV !== 'production',
    appTitle: process.env.REACT_APP_TITLE,
    sentryDns: process.env.REACT_APP_SENTRY_DNS,
    url: process.env.REACT_APP_URL,
    liteVersion: process.env.REACT_APP_LITE_VERSION,
    helpUrl: process.env.REACT_APP_HELP_URL,
})

if (env.isProduction && !env.sentryDns) {
    throw new Error('If environment is production, ENV variable should contain sentry dns')
}

export default env
